(function () {
    'use strict';

    angular.module("imApp").factory("domObjectTypesService", [function () {
        let service = {};

        return service;
    }]);
})();
